import React, { Component } from 'react';
import { MediaItemShape, MediaCacheShape } from 'utils/shapes';
import PropTypes from 'prop-types';
import connect from 'react-redux/es/connect/connect';
import ArenaIconBar from 'components/arena/ArenaIconBar';
import { loadPageSpecificItems } from '../../ducks/arena';

const mapStateToProps = (state) => ({
    mediaCacheId: state.mediaCacheId,
    items: state.items,
    pageSpecificItems: state.pageSpecificItems,
});

const mapDispatchToProps = (dispatch) => ({
    loadPageSpecificItems: (mediaId) => dispatch(loadPageSpecificItems(mediaId)),
});

@connect(mapStateToProps, mapDispatchToProps)
class ArenaBarStandaloneWrapper extends Component {
    // We don't know the mediaCacheId for this item at initialization time

    static propTypes = {
        mediaCacheId: PropTypes.number,
        pageSpecificItems: PropTypes.objectOf(MediaCacheShape).isRequired,

        // loaded from DJ_CONST in routeMap.js
        initialItem: MediaItemShape.isRequired,

        // overrideable
        commentsLink: PropTypes.string,

        loadPageSpecificItems: PropTypes.func.isRequired,
    };

    static defaultProps = {
        mediaCacheId: null,
        commentsLink: null,
    };

    componentDidMount() {
        // Load Media Cache Item for this media ID
        this.props.loadPageSpecificItems(this.props.initialItem.id);
    }

    render() {
        let item;
        if (this.props.mediaCacheId) {
            item = this.props.pageSpecificItems[this.props.mediaCacheId];
        } else {
            item = this.props.initialItem;
        }
        return (
            <ArenaIconBar
                item={item}
                commentsLink={this.props.commentsLink || `${this.props.initialItem.link}#comments`}
            />
        );
    }
}

export default ArenaBarStandaloneWrapper;



// WEBPACK FOOTER //
// ./src/components/arena/ArenaBarStandaloneWrapper.js